import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { listCompanies, listSignupRequests, platformLogs, platformStats, systemHealthFlags } from "../api/platform";
import { useAuth } from "../context/AuthContext";
import { useAutoRefresh } from "../hooks/useAutoRefresh";
import { PlatformHeader } from "../features/platform/PlatformHeader";
import { PlatformTabs } from "../features/platform/PlatformTabs";
import { PlatformTabPanel } from "../features/platform/PlatformTabPanel";
import { TAB_KEYS } from "../features/platform/platformTabList";

// لقطة تبقى بين الزيارات: تعرض آخر بيانات لوحة المالك فورًا (بلا إطار تحميل) ثم تُحدَّث في الخلفية.
let SNAP = null;

export default function PlatformPage() {
  const { signOut, user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [state, setState] = useState(SNAP || { stats: {}, companies: [], logs: [], requests: [], health: 0 });
  const [adding, setAdding] = useState(false);
  const tab = TAB_KEYS.includes(params.get("tab")) ? params.get("tab") : "overview";
  const sub = params.get("sub") || "code";

  const load = async () => {
    const [stats, companies, logs, requests, health] = await Promise.all([
      platformStats(),
      listCompanies(),
      platformLogs(),
      listSignupRequests(),
      systemHealthFlags().catch(() => ({ count: 0 })),
    ]);
    const next = { stats, companies, logs, requests, health: health.count || 0 };
    SNAP = next;
    setState(next);
  };
  const { refresh } = useAutoRefresh(load, 15000);
  const openTab = (key) => {
    setParams(key === "overview" ? {} : { tab: key });
    window.scrollTo({ top: 0 });
  };

  const openSub = (key) => setParams({ tab: "system", sub: key });

  return (
    <div className="min-h-[100dvh] bg-background px-5 py-6 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <PlatformHeader
          user={user}
          onLogout={signOut}
          onAdd={() => {
            openTab("companies");
            setAdding(true);
          }}
        />

        <PlatformTabs
          active={tab}
          onChange={openTab}
          counts={{
            companies: state.companies.length,
            requests: state.requests.length,
            logs: state.logs.length,
            health: state.health,
          }}
        />

        <div className="mt-6" data-testid={`platform-panel-${tab}`}>
          <PlatformTabPanel
            tab={tab}
            state={state}
            adding={adding}
            setAdding={setAdding}
            reload={refresh}
            sub={sub}
            onSub={openSub}
          />
        </div>
      </div>
    </div>
  );
}
